import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';
import { MessageService } from 'primeng/components/common/messageservice';
import { Distributor } from '../models/distributor';
import {GroupRightService} from '../services/group-right.service';
import {GroupRight} from '../models/group-right';

@Component({
	selector: 'app-distributors',
	templateUrl: './distributors.component.html',
	styleUrls: ['./distributors.component.css']
})

export class DistributorsComponent implements OnInit
{
	public distributors: Distributor[];
	public filteredDistributors: Distributor[];
	public groupRight: GroupRight = null;

	isFilterModalOpen: boolean = false; // Property to control the filter modal state
	hasActiveContractFilter: boolean = true; // Property to store the has_active_contract filter state

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private messageService: MessageService,
		private groupRightService: GroupRightService,
	)
	{
	}

	ngOnInit()
	{
		if (this.route.snapshot.data['groupRights'] instanceof Array) {
			this.groupRight = this.groupRightService.getGroupRightForModule('distributor', this.route.snapshot.data['groupRights'])
		}

		if (this.route.snapshot.data['distributors'] instanceof Response)
		{
			// Some unhandled error occurred.
			this.distributors = [];
			let errorMessage = 'Er is een fout opgetreden tijdens het ophalen van de verspreiders.';

			if (this.route.snapshot.data['distributors'].status == 403) {
				errorMessage = 'Je hebt niet genoeg rechten om de verspreidpartners te bekijken.';
			}
			this.messageService.add({
				severity: 'error',
				summary: 'Fout',
				detail: errorMessage
			});
		}
		else if (this.route.snapshot.data['distributors'] instanceof Array)
		{
			// Data was received.
			let distributors = this.route.snapshot.data['distributors'];
			this.distributors = distributors;
			this.filteredDistributors = distributors.filter(distributor => distributor.has_active_contract === true);
		}
		else
		{
			// An error occurred but was already handled.
			this.distributors = [];
		}
	}

	openFilterModal() {
		this.isFilterModalOpen = true;
	}

	closeFilterModal() {
		this.isFilterModalOpen = false;
	}

	applyFilter() {
		this.filteredDistributors = this.distributors.filter(distributor =>
			this.hasActiveContractFilter ? distributor.has_active_contract : true
		);
		this.closeFilterModal();
	}

	public openDistributor(distributor: Distributor)
	{
		this.router.navigate(['/verspreiders', distributor.id]);
	}

	public createDistributor()
	{
		this.router.navigate(['/verspreiders/aanmaken']);
	}

	public hasUserAccess(action)
	{
		return this.groupRight && this.groupRight[action];
	}
}



// WEBPACK FOOTER //
// ./src/app/distributors/distributors.component.ts